// Generates a digest for the given data
// using the specified algorithm
export async function toDigest(data) {
  let algorithm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SHA-256';
  const dataUint8 = new TextEncoder().encode(data); // encode as (utf-8) Uint8Array

  const hashBuffer = await window.crypto.subtle.digest(algorithm, dataUint8); // hash the message

  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array

  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string

  return hashHex;
}